import { findElement, selectedElementAll } from "../utils/element-handlers.utils";

export default function initStickyComponent() {
    const topbarElement = findElement('.n-topbar');
    const topbarInnerElement = topbarElement ? findElement('.n-topbar-inner', topbarElement) : null;
    const stickyObjects: ({render: () => void})[] = [];

    selectedElementAll('.n-sticky', stickyElement => {
        stickyObjects.push(createStickyObject(stickyElement));
    });

    window.addEventListener('scroll', renderAllSticky);

    function createStickyObject(stickyElement: HTMLElement) {
        let previousGlobalTopPosition = 0;

        return {
            render: function () {
                const currentGlobalTopPosition = getGlobalTopPosition();
                const realYPosition = stickyElement.getBoundingClientRect().y;
                const yPosition = Math.max(Math.round(realYPosition), 0);
                const isPinned = !!((yPosition === 0) || (yPosition === previousGlobalTopPosition) || (yPosition && (yPosition < previousGlobalTopPosition)));
    
                stickyElement.classList.toggle('n-pinned', isPinned);
                stickyElement.style.top = currentGlobalTopPosition + 'px';
    
                previousGlobalTopPosition = currentGlobalTopPosition;
            }
        }
    }

    function renderAllSticky() {
        stickyObjects.forEach(function (stickyObject) {
            stickyObject.render();
        });
    }

    function getGlobalTopPosition() {
        if (topbarInnerElement) {
            return topbarInnerElement.offsetTop;
        }

        return 0;
    }
}
